if (!customElements.get('sg-announcement-marquee')) {
  customElements.define('sg-announcement-marquee', class extends HTMLElement {
    connectedCallback() {
      this.onSelect = () => { this.dataset.paused = 'true'; };
      this.onDeselect = () => { this.dataset.paused = 'false'; };
      this.addEventListener('shopify:block:select', this.onSelect);
      this.addEventListener('shopify:block:deselect', this.onDeselect);
      this.resizeObserver = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--announcement--height', `${this.offsetHeight.toFixed(2)}px`);
      });
      this.resizeObserver.observe(this);
    }
    disconnectedCallback() {
      this.removeEventListener('shopify:block:select', this.onSelect);
      this.removeEventListener('shopify:block:deselect', this.onDeselect);
      this.resizeObserver?.disconnect();
    }
  });
}
